import { useMediaQuery, useTheme } from "@mui/material"

export const useMedia = () => {

  const theme = useTheme()
  const isUnder1536px = useMediaQuery(theme.breakpoints.down('xl'))
  const isUnder1200px = useMediaQuery(theme.breakpoints.down('lg'))
  const isUnder900px = useMediaQuery(theme.breakpoints.down('md'))
  const isUnder600px = useMediaQuery(theme.breakpoints.down('sm'))
  const { innerWidth: windowWidth, innerHeight: windowHeight } = window;

  return {windowWidth, windowHeight, isUnder1536px, isUnder1200px, isUnder900px, isUnder600px}
}
